import React from 'react';
import { Form, Select, Input } from 'antd';
import PropTypes from 'prop-types';
import { REGISTER_DIALOG_DESCRIPTION } from '../constants';

import './RegisterModelForm.css';

const { Option, OptGroup } = Select;
const { TextArea } = Input;
export const CREATE_NEW_MODEL_OPTION_VALUE = '$$new$$';
export const SELECTED_MODEL_FIELD = 'selectedModel';
export const MODEL_NAME_FIELD = 'modelName';
export const DESCRIPTION_FIELD = 'description';

// This can be enabled after we support description in CreatModel & CreateModelVersion
const ENABLE_DESCRIPTION = false;

class RegisterModelFormComponent extends React.Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    modelByName: PropTypes.object,
  };

  state = {
    selectedModel: null,
  };

  handleModelSelectChange = (selectedModel) => {
    this.setState({ selectedModel });
  };

  modelNameValidator = (rule, value, callback) => {
    const { modelByName } = this.props;
    callback(modelByName[value] ? `Model "${value}" already exists.` : undefined);
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { modelByName } = this.props;
    const { selectedModel } = this.state;
    const creatingNewModel = selectedModel === CREATE_NEW_MODEL_OPTION_VALUE;
    return (
      <Form layout='vertical' className='register-model-form'>
        <p className='modal-explanatory-text'>{REGISTER_DIALOG_DESCRIPTION}</p>

        {/* "+ Create new model" OR "Select existing model" */}
        <Form.Item label='Model'>
          {getFieldDecorator(SELECTED_MODEL_FIELD, {
            rules: [
              { required: true, message: 'Please select a model or create a new one.' },
            ],
          })(
            <Select
              dropdownClassName='model-select-dropdown'
              onChange={this.handleModelSelectChange}
              placeholder='Select a model'
            >
              <Option value={CREATE_NEW_MODEL_OPTION_VALUE} className='create-new-model-option'>
                <i className='fa fa-plus fa-fw' style={{ fontSize: 13 }} /> Create New Model
              </Option>
              <OptGroup label='Models'>
                {Object.values(modelByName).map((model) => (
                  <Option value={model.name} key={model.name}>
                    {model.name}
                  </Option>
                ))}
              </OptGroup>
            </Select>,
          )}
        </Form.Item>

        {/* Name the new model when "+ Create new model" is selected */}
        {creatingNewModel ? (
          <Form.Item label='Model Name'>
            {getFieldDecorator(MODEL_NAME_FIELD, {
              rules: [
                { required: true, message: 'Please input a name for the new model.' },
                { validator: this.modelNameValidator },
              ],
            })(<Input placeholder='Input a model name' />)}
          </Form.Item>
        ) : null}

        {/* Model/Model Version Description */}
        { ENABLE_DESCRIPTION && selectedModel ? (
          <Form.Item label='Description'>
            {getFieldDecorator(DESCRIPTION_FIELD)(
              <TextArea
                rows={3}
                placeholder={`Description for the new ${creatingNewModel ? 'model' : 'version'}`}
              />
            )}
          </Form.Item>
        ) : null}

        {/* Explanatory text shown when existing model is selected */}
        {selectedModel && !creatingNewModel ? (
          <p className='modal-explanatory-text'>
            The model will be registered as a new version of {selectedModel}.
          </p>
        ) : null}
      </Form>
    );
  }
}

export const RegisterModelForm = Form.create()(RegisterModelFormComponent);



// WEBPACK FOOTER //
// ./src/model-registry/components/RegisterModelForm.js